import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	projectDetails: null,
	projectMembers: [],
	selectedColumnToHide: [],
	groupList: [],
	taskList: [],
	originalTaskList: []
};

const myProjectDetailsSlice = createSlice({
	name: 'myProjectDetailsSlice',
	initialState,
	reducers: {
		setProjectDetails: (state, action) => {
			state.projectDetails = action.payload;
		},
		setProjectMembers: (state, action) => {
			state.projectMembers = action.payload;
		},
		setSelectedColumnToHide: (state, action) => {
			state.selectedColumnToHide = action.payload;
		},
		setGroupList: (state, action) => {
			state.groupList = action.payload;
		},
		setTaskList: (state, action) => {
			state.taskList = action.payload;
		},
		setOriginalTaskList: (state, action) => {
			state.originalTaskList = action.payload;
		}
	}
});

export const {
	setProjectDetails,
	setProjectMembers,
	setSelectedColumnToHide,
	setGroupList,
	setTaskList,
	setOriginalTaskList
} = myProjectDetailsSlice.actions;

export default myProjectDetailsSlice.reducer;
